module.exports = __webpack_public_path__ + "static/construction-0bedac1e6c3438ddb34a3f6e60fcd89e.png";